// Generated by AvenyModelEditor

import { IClientSubSystemModel } from '../../Types/ClientModelTypes';
import { TEDSelectionOperator as T} from '../../globalQueryTypes';

const KJ: IClientSubSystemModel = {
  Code: 'KJ',
  DisplayLabel: 'Kremationsjournal',
  BusinessModels: {
    KJBegravningsPlats: {
      CollectionName: 'KJBegravningsPlats',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Begravningsplats',
        Abstract: false,
        SOLabel: 'Begravningsplats',
        SOGLabel: 'Begravningsplats',
        SBLabel: 'Begravningsplatsen',
        SBGLabel: 'Begravningsplatsen',
        POLabel: 'Begravningsplatser',
        POGLabel: 'Begravningsplatser',
        PBLabel: 'Begravningsplatserna',
        PBGLabel: 'Begravningsplatserna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Begravningsplatsen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Begravningsplatsen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Begravningsplatsen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Begravningsplatsen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BEGRAVNINGSPLATS: {
          AttributeName: 'BEGRAVNINGSPLATS',
          DisplayLabel: 'Begravningsplats',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 6,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        RESURS_ID: {
          AttributeName: 'RESURS_ID',
          DisplayLabel: 'ResursID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        x_Exportable_ResursNamn: {
          AttributeName: 'x_Exportable_ResursNamn',
          DisplayLabel: 'ResursNamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        x_ExportableCond_ResursID: {
          AttributeName: 'x_ExportableCond_ResursID',
          DisplayLabel: 'ResursID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Resurs: {
          AssociationName: 'Resurs',
          DisplayLabel: 'Resurs',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOResurs',
          AssociatedComponentName: 'Resurs',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    KJKremationActiveX: {
      CollectionName: 'KJKremationActiveX',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'KremationActiveX',
        Abstract: false,
        SOLabel: 'Dokument',
        SOGLabel: 'Dokuments',
        SBLabel: 'Dokumentet',
        SBGLabel: 'Dokumentets',
        POLabel: 'Dokument',
        POGLabel: 'Dokuments',
        PBLabel: 'Dokumenten',
        PBGLabel: 'Dokumentens',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Dokumentets primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Dokumentets versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Dokumentets fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KREMATIONS_ID: {
          AttributeName: 'KREMATIONS_ID',
          DisplayLabel: 'KremationsID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LOPNR: {
          AttributeName: 'LOPNR',
          DisplayLabel: 'Löpnummer',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BESKRIVNING: {
          AttributeName: 'BESKRIVNING',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        FILNAMN: {
          AttributeName: 'FILNAMN',
          DisplayLabel: 'Filnamn (länk)',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        SENAST_ANDRAD: {
          AttributeName: 'SENAST_ANDRAD',
          DisplayLabel: 'Senast ändrad',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        DATA: {
          AttributeName: 'DATA',
          DisplayLabel: 'Data',
          DataType: 'ID',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        DATASIZE: {
          AttributeName: 'DATASIZE',
          DisplayLabel: 'Datastorlek',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        DATATYPE: {
          AttributeName: 'DATATYPE',
          DisplayLabel: 'Datatyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        EXTENSION: {
          AttributeName: 'EXTENSION',
          DisplayLabel: 'Filändelse',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    KJKremListKol: {
      CollectionName: 'KJKremListKol',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'True']]),
      RootType: {
        TypeValue: 'KremListKol',
        Abstract: false,
        SOLabel: 'Kolumn',
        SOGLabel: 'Kolumn',
        SBLabel: 'Kolumnen',
        SBGLabel: 'Kolumnen',
        POLabel: 'Kolumner',
        POGLabel: 'Kolumner',
        PBLabel: 'Kolumnerna',
        PBGLabel: 'Kolumnerna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kolumnen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kolumnen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Kolumnen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kolumnen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TITEL: {
          AttributeName: 'TITEL',
          DisplayLabel: 'Titel',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        ORDNING: {
          AttributeName: 'ORDNING',
          DisplayLabel: 'Ordning',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Typ',
          Hint: 'Inom förvaltningen/Utanför förvaltningen/Ej avhämtad aska/Totalsumma',
          DataType: 'Enum',
          EnumValues: new Map([['INOM_FORVALTNINGEN', 'Inom förvaltningen'], ['UTANFOR_FORVALTNINGEN', 'Utanför förvaltningen'], ['EJ_AVHAMTAD_ASKA', 'Ej avhämtad aska'], ['TOTALSUMMA', 'Totalsumma']]),
          EnumSortValues: new Map([['INOM_FORVALTNINGEN', 'F'], ['UTANFOR_FORVALTNINGEN', 'U'], ['EJ_AVHAMTAD_ASKA', 'E'], ['TOTALSUMMA', 'T']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="INOM_FORVALTNINGEN=Inom förvaltningen;UTANFOR_FORVALTNINGEN=Utanför förvaltningen;EJ_AVHAMTAD_ASKA=Ej avhämtad aska;TOTALSUMMA=Totalsumma"',
          InterfaceType: 'ifChecklist',
        },
        UPPDELNING: {
          AttributeName: 'UPPDELNING',
          DisplayLabel: 'Uppdelning',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TypBen: {
          AttributeName: 'TypBen',
          DisplayLabel: 'Typ',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Lista: {
          AssociationName: 'Lista',
          DisplayLabel: 'Lista',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'KJKremList',
          AssociatedComponentName: 'KremList',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    KJKremation: {
      CollectionName: 'KJKremation',
      UDAEnabled: true,
      UDNEnabled: true,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '5001']]),
      RootType: {
        TypeValue: 'Kremationsjournal',
        Abstract: false,
        SOLabel: 'Kremationsjournal',
        SOGLabel: 'Kremationsjournal',
        SBLabel: 'Kremationsjournalen',
        SBGLabel: 'Kremationsjournalen',
        POLabel: 'Kremationsjournaler',
        POGLabel: 'Kremationsjournaler',
        PBLabel: 'Kremationsjournalerna',
        PBGLabel: 'Kremationsjournalerna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kremationsjournalen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kremationsjournalen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Kremationsjournalen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kremationsjournalen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AKT_MED_URNA: {
          AttributeName: 'AKT_MED_URNA',
          DisplayLabel: 'Akt med urna',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          ValidInComps: ['BOBegrGrav'],
        },
        ANHORIG_ID: {
          AttributeName: 'ANHORIG_ID',
          DisplayLabel: 'AnhörigID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Antaldagar: {
          AttributeName: 'Antaldagar',
          DisplayLabel: 'Dagar döds-krem',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
        },
        AVDELNING_ID: {
          AttributeName: 'AVDELNING_ID',
          DisplayLabel: 'Avdelning',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AVHAMTARE: {
          AttributeName: 'AVHAMTARE',
          DisplayLabel: 'Avhämtare från kremation',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCase',
          GUIEditable: true,
          MaxInputLength: 60,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        AvhamtareBJ: {
          AttributeName: 'AvhamtareBJ',
          DisplayLabel: 'Avhämtare från bisättning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        AvhamtareSen: {
          AttributeName: 'AvhamtareSen',
          DisplayLabel: 'Avhämtare',
          Hint: 'Senaste avhämtare från kremation/bisättning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        AVHAMTDATUM: {
          AttributeName: 'AVHAMTDATUM',
          DisplayLabel: 'Avhämtningsdatum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'Internal',
          Formatter: 'TEDFormatDate',
          FormatterParseParams: 'CenturyLimit="0"',
          FormatterValidateParams: 'MaxRecommendedDate="+2m"',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        Avhamtningsdatum: {
          AttributeName: 'Avhamtningsdatum',
          DisplayLabel: 'Avhämtningsdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        AVLIDEN_REF_ID: {
          AttributeName: 'AVLIDEN_REF_ID',
          DisplayLabel: 'Avliden',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BegrAktID: {
          AttributeName: 'BegrAktID',
          DisplayLabel: 'Begravningsaktivitet',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BEGRAVDAT: {
          AttributeName: 'BEGRAVDAT',
          DisplayLabel: 'Begravningsdatum',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDateStr',
          FormatterParseParams: 'CenturyLimit="0";AllowIncomplete="Y";AllowZero="Y"',
          FormatterValidateParams: 'MaxRecommendedDate="+2m"',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        BEGRAVNINGSORT_ID: {
          AttributeName: 'BEGRAVNINGSORT_ID',
          DisplayLabel: 'Fakturaadress ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BEGRAVTID: {
          AttributeName: 'BEGRAVTID',
          DisplayLabel: 'Begravningstid',
          DataType: 'Time',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatTimeMinute',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        BEGRBYRA_ID: {
          AttributeName: 'BEGRBYRA_ID',
          DisplayLabel: 'Begravningsbyrå ID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        BEGRBYRA_KONTAKT: {
          AttributeName: 'BEGRBYRA_KONTAKT',
          DisplayLabel: 'Begravningsbyrå kontakt',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 40,
        },
        BEGRBYRA_KONTAKT_INFO: {
          AttributeName: 'BEGRBYRA_KONTAKT_INFO',
          DisplayLabel: 'Begravningsbyrå kontaktinformation',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 255,
        },
        BEGRPLATS: {
          AttributeName: 'BEGRPLATS',
          DisplayLabel: 'Begravningsplats',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCase',
          FormatterParseParams: 'Words=" False"',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        BEGRPLATS_ID: {
          AttributeName: 'BEGRPLATS_ID',
          DisplayLabel: 'Begravningsplats',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        DODSDATUM: {
          AttributeName: 'DODSDATUM',
          DisplayLabel: 'Dödsdatum',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDateStr',
          FormatterParseParams: 'CenturyLimit="0";AllowIncomplete="Y";AllowZero="Y"',
          FormatterValidateParams: 'MaxDate="+0m"',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        FinnsUtcheckadBisattning: {
          AttributeName: 'FinnsUtcheckadBisattning',
          DisplayLabel: 'Finns utcheckad för kremation',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        FOSTER: {
          AttributeName: 'FOSTER',
          DisplayLabel: 'Persnr. saknas',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        FOSTERNUMMER: {
          AttributeName: 'FOSTERNUMMER',
          DisplayLabel: 'Nummer (persnr. saknas)',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GDPRGravsDatum: {
          AttributeName: 'GDPRGravsDatum',
          DisplayLabel: 'Gravsättningsdatum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        GravNr: {
          AttributeName: 'GravNr',
          DisplayLabel: 'Gravplatsnummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GRAVPLATSNR: {
          AttributeName: 'GRAVPLATSNR',
          DisplayLabel: 'Gravnummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GravsAktID: {
          AttributeName: 'GravsAktID',
          DisplayLabel: 'Gravsättningsaktivitet',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GRAVSATT: {
          AttributeName: 'GRAVSATT',
          DisplayLabel: 'Gravsatt',
          Hint: 'Nej/Ja',
          DataType: 'Enum',
          EnumValues: new Map([['NEJ', 'Nej'], ['JA', 'Ja']]),
          EnumSortValues: new Map([['NEJ', 'N'], ['JA', 'Y']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NEJ=Nej;JA=Ja"',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        GRAVSATTNINGSORT_ID: {
          AttributeName: 'GRAVSATTNINGSORT_ID',
          DisplayLabel: 'Gravsättningsort ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GRAVSDATUM: {
          AttributeName: 'GRAVSDATUM',
          DisplayLabel: 'Gravsättningsdatum',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDateStr',
          FormatterParseParams: 'CenturyLimit="0";AllowIncomplete="Y";AllowZero="Y"',
          FormatterValidateParams: 'MaxRecommendedDate="+2m"',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        GRAVSTID: {
          AttributeName: 'GRAVSTID',
          DisplayLabel: 'Gravsättningstid',
          DataType: 'Time',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatTimeMinute',
        },
        GRAVTYP: {
          AttributeName: 'GRAVTYP',
          DisplayLabel: 'Gravsättningstyp',
          Hint: 'Urna/Urnkammare/Nisch/Aska/Minneslund/Askgravlund',
          DataType: 'Enum',
          EnumValues: new Map([['URNA', 'Urna'], ['URNKAMMARE', 'Urnkammare'], ['NISCH', 'Nisch'], ['ASKA', 'Aska'], ['MINNESLUND', 'Minneslund'], ['ASKGRAVLUND', 'Askgravlund']]),
          EnumSortValues: new Map([['URNA', 'U'], ['URNKAMMARE', 'R'], ['NISCH', 'N'], ['ASKA', 'A'], ['MINNESLUND', 'M'], ['ASKGRAVLUND', 'S']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="URNA=Urna;URNKAMMARE=Urnkammare;NISCH=Nisch;ASKA=Aska;MINNESLUND=Minneslund;ASKGRAVLUND=Askgravlund"',
        },
        harDokument: {
          AttributeName: 'harDokument',
          DisplayLabel: 'harDokument',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        harNotering: {
          AttributeName: 'harNotering',
          DisplayLabel: 'harNotering',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        harOrder: {
          AttributeName: 'harOrder',
          DisplayLabel: 'harOrder',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        INTYGSDATUM: {
          AttributeName: 'INTYGSDATUM',
          DisplayLabel: 'Intyg kremering',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          FormatterParseParams: 'CenturyLimit="0"',
          FormatterValidateParams: 'MaxRecommendedDate="+2m"',
        },
        KGARD_ANNANORT_ID: {
          AttributeName: 'KGARD_ANNANORT_ID',
          DisplayLabel: 'Kyrkogård annan ort',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['TaBort', 'true']]),
        },
        KGARD_ID: {
          AttributeName: 'KGARD_ID',
          DisplayLabel: 'Kyrkogård',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KGARDANNANORT: {
          AttributeName: 'KGARDANNANORT',
          DisplayLabel: 'Gravsättning annan ort',
          Hint: 'Gravsättning annan ort',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatCase',
          FormatterParseParams: 'Words=" False"',
          Properties: new Map([['TaBort', 'true'], ['ffMaskedValue', 'Y']]),
        },
        KREMATORIUM_ID: {
          AttributeName: 'KREMATORIUM_ID',
          DisplayLabel: 'Krematorium',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KREMDATUM: {
          AttributeName: 'KREMDATUM',
          DisplayLabel: 'Kremationsdatum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          FormatterParseParams: 'CenturyLimit="0"',
          FormatterValidateParams: 'MaxRecommendedDate="+2m"',
        },
        Kvarter: {
          AttributeName: 'Kvarter',
          DisplayLabel: 'Benämning kyrkogård/kvarter/avdelning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KVARTER_LOPNR: {
          AttributeName: 'KVARTER_LOPNR',
          DisplayLabel: 'Kvarter',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MARKERAD_FAKTURERAD: {
          AttributeName: 'MARKERAD_FAKTURERAD',
          DisplayLabel: 'Markerad som fakturerad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        MaskTypeAvliden: {
          AttributeName: 'MaskTypeAvliden',
          DisplayLabel: 'Sekretessmarkerad av Skatteverket',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="S=Sekretess;P=Skyddad"',
          InterfaceType: 'ifChecklist',
          AttributeGroup: 'Dolda uppgifter',
          Properties: new Map([['UsesMask', 'Y']]),
        },
        MaskValuesAvliden: {
          AttributeName: 'MaskValuesAvliden',
          DisplayLabel: 'Dolda uppgifter (person)',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Internal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifFilter',
          AttributeGroup: 'Dolda uppgifter',
          Properties: new Map([['UsesMask', 'Y']]),
        },
        Namn: {
          AttributeName: 'Namn',
          DisplayLabel: 'Namn',
          Hint: 'Efternamn, förnamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        NamnFE: {
          AttributeName: 'NamnFE',
          DisplayLabel: 'Namn (förnamn efternamn)',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        NamnTNamn: {
          AttributeName: 'NamnTNamn',
          DisplayLabel: 'Namn och tilltalsnamn',
          Hint: 'Efternamn, förnamn, tilltalsnamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        NR: {
          AttributeName: 'NR',
          DisplayLabel: 'Kremationsnummer',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        PLANERAD_KREMDATUM: {
          AttributeName: 'PLANERAD_KREMDATUM',
          DisplayLabel: 'Planerad kremationsdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterParseParams: 'CenturyLimit="0"',
          FormatterValidateParams: 'MaxRecommendedDate="+2m"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        RELATION: {
          AttributeName: 'RELATION',
          DisplayLabel: 'Relation',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCase',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        SEKRETESSMARKERAD: {
          AttributeName: 'SEKRETESSMARKERAD',
          DisplayLabel: 'Sekretessmarkerad av förvaltningen',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="L=Tillfälligt spärrad"',
          GUIEditable: true,
          MaxInputLength: 1,
          Properties: new Map([['UsesMask', 'Y']]),
        },
        TVIST: {
          AttributeName: 'TVIST',
          DisplayLabel: 'Tvist föreligger',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        TvistGravs: {
          AttributeName: 'TvistGravs',
          DisplayLabel: 'Tvist gravsättning',
          Hint: 'Ja/Nej',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        TvistKrem: {
          AttributeName: 'TvistKrem',
          DisplayLabel: 'Tvist kremering',
          Hint: 'Ja/Nej',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        TYP_URNA: {
          AttributeName: 'TYP_URNA',
          DisplayLabel: 'Typ av urna',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        UtcheckadBisattningID: {
          AttributeName: 'UtcheckadBisattningID',
          DisplayLabel: 'Slå upp bisättning',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Krematorium: {
          AssociationName: 'Krematorium',
          DisplayLabel: 'Krematorium',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KJKrematorium',
          AssociatedComponentName: 'Krematorium',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Begravningsplats: {
          AssociationName: 'Begravningsplats',
          DisplayLabel: 'Begravningsplats',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOResurs',
          AssociatedComponentName: 'Resurs',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Anhorig: {
          AssociationName: 'Anhorig',
          DisplayLabel: 'Anhörig',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'Person',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['NOT_ATAGANDE', 'Y']]),
        },
        Begravningsbyra: {
          AssociationName: 'Begravningsbyra',
          DisplayLabel: 'Begravningsbyrå',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'Organisation',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Begravningsort: {
          AssociationName: 'Begravningsort',
          DisplayLabel: 'Fakturaadress',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'SamfallighetForsamling',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Begravning: {
          AssociationName: 'Begravning',
          DisplayLabel: 'Begravning (aktivitet)',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOAktivitet',
          AssociatedComponentName: 'Begravning',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Avlidna: {
          AssociationName: 'Avlidna',
          DisplayLabel: 'Avlidna',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPAvliden',
          AssociatedComponentName: 'Avliden',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['IntegratedFilter', 'OP_NR;'], ['OverrideDisplayLabels', 'Avlidna.Person.PERS_NR="Personnummer",Avlidna.Person.PERS_NR="Personnummer",Avlidna.Person.OP_Namn="Efternamn",Avlidna.Person.NamnME="Efternamn",G:Person="";']]),
        },
        UtcheckadBisattning: {
          AssociationName: 'UtcheckadBisattning',
          DisplayLabel: 'Utcheckad bisättning',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOBisattning',
          AssociatedComponentName: 'Bisattningsjournal',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        KremationOrder: {
          AssociationName: 'KremationOrder',
          DisplayLabel: 'Order',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KJTEDKJKremationOrder',
          AssociatedComponentName: 'KremationOrder',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Dokument: {
          AssociationName: 'Dokument',
          DisplayLabel: 'Dokument',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'KJKremationActiveX',
          AssociatedComponentName: 'KremationActiveX',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    KJKremList: {
      CollectionName: 'KJKremList',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'True']]),
      RootType: {
        TypeValue: 'KremList',
        Abstract: false,
        SOLabel: 'Kremationslista',
        SOGLabel: 'Kremationslista',
        SBLabel: 'Kremationslistan',
        SBGLabel: 'Kremationslistan',
        POLabel: 'Kremationslistor',
        POGLabel: 'Kremationslistor',
        PBLabel: 'Kremationslistorna',
        PBGLabel: 'Kremationslistorna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kremationslistan primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kremationslistan versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Kremationslistan id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kremationslistan fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Required: true,
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Typ',
          Hint: 'Kremationsstatistik',
          DataType: 'Enum',
          EnumValues: new Map([['KREMATIONSSTATISTIK', 'Kremationsstatistik']]),
          EnumSortValues: new Map([['KREMATIONSSTATISTIK', 'K']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="KREMATIONSSTATISTIK=Kremationsstatistik"',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        INST: {
          AttributeName: 'INST',
          DisplayLabel: 'Egenskaper',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VISA_INST: {
          AttributeName: 'VISA_INST',
          DisplayLabel: 'Visa kod/benämning',
          Hint: 'Fullständig benämning/Endast benämning/Endast kod',
          DataType: 'Enum',
          EnumValues: new Map([['FULLSTANDIG_BENAMNING', 'Fullständig benämning'], ['ENDAST_BENAMNING', 'Endast benämning'], ['ENDAST_KOD', 'Endast kod']]),
          EnumSortValues: new Map([['FULLSTANDIG_BENAMNING', 'F'], ['ENDAST_BENAMNING', 'B'], ['ENDAST_KOD', 'K']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FULLSTANDIG_BENAMNING=Fullständig benämning;ENDAST_BENAMNING=Endast benämning;ENDAST_KOD=Endast kod"',
        },
        GRUPP1_TYP: {
          AttributeName: 'GRUPP1_TYP',
          DisplayLabel: 'Grupperingsbegrepp 1',
          Hint: 'Län/Kommun/Församling',
          DataType: 'Enum',
          EnumValues: new Map([['LAN', 'Län'], ['KOMMUN', 'Kommun'], ['FORSAMLING', 'Församling']]),
          EnumSortValues: new Map([['LAN', 'L'], ['KOMMUN', 'K'], ['FORSAMLING', 'F']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="LAN=Län;KOMMUN=Kommun;FORSAMLING=Församling"',
        },
        GRUPP1_INST: {
          AttributeName: 'GRUPP1_INST',
          DisplayLabel: 'Grupperingsbegrepp 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GRUPP2_TYP: {
          AttributeName: 'GRUPP2_TYP',
          DisplayLabel: 'Grupperingsbegrepp 2',
          Hint: 'Län/Kommun/Församling',
          DataType: 'Enum',
          EnumValues: new Map([['LAN', 'Län'], ['KOMMUN', 'Kommun'], ['FORSAMLING', 'Församling']]),
          EnumSortValues: new Map([['LAN', 'L'], ['KOMMUN', 'K'], ['FORSAMLING', 'F']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="LAN=Län;KOMMUN=Kommun;FORSAMLING=Församling"',
        },
        GRUPP2_INST: {
          AttributeName: 'GRUPP2_INST',
          DisplayLabel: 'Grupperingsbegrepp 2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GRUPP3_TYP: {
          AttributeName: 'GRUPP3_TYP',
          DisplayLabel: 'Grupperingsbegrepp 3',
          Hint: 'Län/Kommun/Församling',
          DataType: 'Enum',
          EnumValues: new Map([['LAN', 'Län'], ['KOMMUN', 'Kommun'], ['FORSAMLING', 'Församling']]),
          EnumSortValues: new Map([['LAN', 'L'], ['KOMMUN', 'K'], ['FORSAMLING', 'F']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="LAN=Län;KOMMUN=Kommun;FORSAMLING=Församling"',
        },
        GRUPP3_INST: {
          AttributeName: 'GRUPP3_INST',
          DisplayLabel: 'Grupperingsbegrepp 3',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TypBen: {
          AttributeName: 'TypBen',
          DisplayLabel: 'Typ',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Kolumner: {
          AssociationName: 'Kolumner',
          DisplayLabel: 'Kolumner',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'KJKremListKol',
          AssociatedComponentName: 'KremListKol',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    KJTEDKJKremationOrder: {
      CollectionName: 'KJTEDKJKremationOrder',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'KremationOrder',
        Abstract: false,
        SOLabel: 'Kremationsorder',
        SOGLabel: 'Kremationsorders',
        SBLabel: 'Kremationsordern',
        SBGLabel: 'Kremationsorderns',
        POLabel: 'Kremationsordrar',
        POGLabel: 'Kremationsordrars',
        PBLabel: 'Kremationsordrarna',
        PBGLabel: 'Kremationsordrarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kremationsorderns primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kremationsorderns versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Kremationsorderns id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kremationsorderns fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Fakturanr: {
          AttributeName: 'Fakturanr',
          DisplayLabel: 'Fakturanr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Status: {
          AttributeName: 'Status',
          DisplayLabel: 'Status',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Kremationsjournal: {
          AssociationName: 'Kremationsjournal',
          DisplayLabel: 'Kremationsjournal',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'KJKrematorium',
          AssociatedComponentName: 'Krematorium',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        NormalOrder: {
          AssociationName: 'NormalOrder',
          DisplayLabel: 'Order',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OFOrder',
          AssociatedComponentName: 'Order',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    KJKrematorium: {
      CollectionName: 'KJKrematorium',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'True']]),
      RootType: {
        TypeValue: 'Krematorium',
        Abstract: false,
        SOLabel: 'Krematorium',
        SOGLabel: 'Krematorium',
        SBLabel: 'Krematoriet',
        SBGLabel: 'Krematoriet',
        POLabel: 'Krematorium',
        POGLabel: 'Krematorium',
        PBLabel: 'Krematorierna',
        PBGLabel: 'Krematorierna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Krematoriet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Krematoriet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Krematoriet id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Krematoriet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KREMATORIUM: {
          AttributeName: 'KREMATORIUM',
          DisplayLabel: 'Krematorium',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 6,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        KREMSERIE_ID: {
          AttributeName: 'KREMSERIE_ID',
          DisplayLabel: 'Kremationsnummerserie',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AKTIV: {
          AttributeName: 'AKTIV',
          DisplayLabel: 'Aktiv',
          Hint: 'JA/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'JA'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=JA;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Kremationsnummerserie: {
          AssociationName: 'Kremationsnummerserie',
          DisplayLabel: 'Kremationsnummerserie',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSNummerserie',
          AssociatedComponentName: 'StandigNummerserie',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kremationsjournaler: {
          AssociationName: 'Kremationsjournaler',
          DisplayLabel: 'Kremationsjournaler',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'KJKremation',
          AssociatedComponentName: 'Kremationsjournal',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    KJKGardAnnanOrt: {
      CollectionName: 'KJKGardAnnanOrt',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'True']]),
      RootType: {
        TypeValue: 'KGardAnnanOrt',
        Abstract: false,
        SOLabel: 'Kyrkogård annan ort',
        SOGLabel: 'Kyrkogård annan ort',
        SBLabel: 'Kyrkogård på annan ort',
        SBGLabel: 'Kyrkogård på annan ort',
        POLabel: 'Kyrkogårdarna på annan ort',
        POGLabel: 'Kyrkogårdarna på annan ort',
        PBLabel: 'Kyrkogårdar på annan ort',
        PBGLabel: 'Kyrkogårdar på annan ort',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kyrkogård på annan ort primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kyrkogård på annan ort versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Kyrkogård på annan ort id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kyrkogård på annan ort fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KYRKOGARD: {
          AttributeName: 'KYRKOGARD',
          DisplayLabel: 'Kyrkogård annan ort',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 6,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    KJRapportlayout: {
      CollectionName: 'KJRapportlayout',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Rapportlayout',
        Abstract: false,
        SOLabel: 'Rapportlayout',
        SOGLabel: 'Rapportlayout',
        SBLabel: 'Rapportlayouten',
        SBGLabel: 'Rapportlayouten',
        POLabel: 'Rapportlayouter',
        POGLabel: 'Rapportlayouter',
        PBLabel: 'Rapportlayouterna',
        PBGLabel: 'Rapportlayouterna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Rapportlayouten primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Rapportlayouten versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Rapportlayouten id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Rapportlayouten fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LAYOUT: {
          AttributeName: 'LAYOUT',
          DisplayLabel: 'Layout',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Required: true,
        },
        FOOTER_ASKKVITTO: {
          AttributeName: 'FOOTER_ASKKVITTO',
          DisplayLabel: 'Extra rader Askkvitto',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        FOOTER_IDBEVIS: {
          AttributeName: 'FOOTER_IDBEVIS',
          DisplayLabel: 'Extra rader ID-bevis',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        FOOTER_HAMTAURNA: {
          AttributeName: 'FOOTER_HAMTAURNA',
          DisplayLabel: 'Extra rader Hämta urna',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        FOOTER_KREMJ: {
          AttributeName: 'FOOTER_KREMJ',
          DisplayLabel: 'Extra rader Kremationsjournal',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        RAPPORTLAYOUT_ID: {
          AttributeName: 'RAPPORTLAYOUT_ID',
          DisplayLabel: 'Rapportlayout',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RUBRIK_ASKKVITTO: {
          AttributeName: 'RUBRIK_ASKKVITTO',
          DisplayLabel: 'Rubrik Askkvitto',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        RUBRIK_IDBEVIS: {
          AttributeName: 'RUBRIK_IDBEVIS',
          DisplayLabel: 'Rubrik ID-bevis',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        RUBRIK_HAMTAURNA: {
          AttributeName: 'RUBRIK_HAMTAURNA',
          DisplayLabel: 'Rubrik Hämta urna',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        RUBRIK_KREMJ: {
          AttributeName: 'RUBRIK_KREMJ',
          DisplayLabel: 'Rubrik Kremationsjournal',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Rapportlayout: {
          AssociationName: 'Rapportlayout',
          DisplayLabel: 'Rapportlayout',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSFakturalayout',
          AssociatedComponentName: 'Brevlayout',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
  },
};

export default KJ;
